import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";

// importation icons
import { StarRateRounded } from "@mui/icons-material";

// import style
import "./style.css";
import Skeleton from "react-loading-skeleton";

import { useDispatch } from "react-redux";
import { addCart } from "../../redux/action/index";

export default function Prodct() {
    const { id } = useParams();
    const [product, setProduct] = useState([]);
    const [loadeing, setLoadeing] = useState(false);

    const dispatch = useDispatch();

    const addProduct = (product) => {
        dispatch(addCart(product));
    };

    useEffect(() => {
        const getProduct = async () => {
            setLoadeing(true);
            const response = await fetch(
                `https://fakestoreapi.com/products/${id}`
            );
            setProduct(await response.json());
            console.log(response);
            setLoadeing(false);
        };
        getProduct();
    }, []);

    const Loading = () => {
        return (
            <div>
                <div className=" containeer mx-auto md:flex">
                    <div className="w-6/12 flex justify-center ">
                        <Skeleton
                            className="mx-3 mt-10"
                            width={400}
                            height={500}
                        />
                    </div>

                    <div className="w-6/12 ">
                        <Skeleton
                            className="text-6xl my-7 "
                            width={570}
                            height={65}
                        />
                        <Skeleton
                            className="text-7xl mb-5 "
                            count={2}
                            width={815}
                            height={55}
                        />
                        <Skeleton className="mb-5" width={170} height={35} />
                        <Skeleton className="text-7xl mb-5" width={400} />
                        <Skeleton count={2} width={830} />
                        <Skeleton width={500} />
                        <div className="flex mt-10  ">
                            <Skeleton
                                className="mr-5"
                                width={100}
                                height={50}
                            />
                            <Skeleton width={100} height={50} />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const SowProduct = () => {
        return (
            <div className=" containeer mx-auto md:flex md:mt-0 mt-12 ">
                <div className=" product w-6/12 flex justify-center items-center m-auto ">
                    <div className="image mb-5 ">
                        <img
                            className="m-auto"
                            src={product.image}
                            alr={product.title}
                        />
                    </div>
                </div>

                <div className="md:w-6/12 w-12/12 ">
                    <h2 className="md:text-6xl text-4xl mb-7 ">
                        {" "}
                        {product.category}{" "}
                    </h2>
                    <h1 className="md:text-7xl text-6xl mb-5 ">
                        {" "}
                        {product.title}{" "}
                    </h1>
                    <p className="mb-5 text-5xl font-bold">
                        rating {product.rating && product.rating.rate}
                        <StarRateRounded className="text-7xl" />
                    </p>
                    <p className="md:text-7xl text-6xl mb-5">
                        $ {product.price}{" "}
                    </p>
                    <p className="text-3xl"> {product.description} </p>

                    <div className="flex mt-10  ">
                        <button
                            className="p-2.5 mr-5 "
                            onClick={() => addProduct(product)}
                        >
                            add to card
                        </button>
                        <NavLink className="btn p-2.5 " to="/cart">
                            go to card
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    };

    return <div> {loadeing ? <Loading /> : <SowProduct />} </div>;
}
